<div>
  @if (commentable.type == 'status') {
    <div class="feed-item-footer">
      <div class="actions">
        <ut-community-feed-item-like-count [likeable]="commentable"></ut-community-feed-item-like-count>
        <ut-community-feed-item-like-btn [likeable]="commentable"></ut-community-feed-item-like-btn>
        <ut-comment-btn [commentable]="commentable"></ut-comment-btn>
      </div>
      @if (commentable.current_user_permissions.comment) {
        <a
          (click)="openCommentEditor()"
          class="clickable"
          [attr.data-slide-up-trigger]="slideUpId"
          >
          <i class="icon icon-chat"></i>Write a Comment
        </a>
      }
    </div>
  }

  <div class="section-single-comment section-single-comment-dark">

    <!-- CommentItems -->
    @for (comment of comments; track comment) {
      <div
        class="section-single-comment-content feed"
        [id]="'comment_' + comment.id">
        <div class="indent" [ngClass]="'indent-' + comment.indentation">
          <a class="feed-header clearfix" [uiSref]="'profile.about'" [uiParams]="{profileId: comment.user.slug}" [attr.aria-label]="'Comment Author, ' + comment.user.name + ', ' + (comment.published_at | relativeDate)">
            <div class="feed-header-info-icon">
              <ut-avatar-badges [user]="comment.user"></ut-avatar-badges>
            </div>
            <div class="feed-header-info-name">
              {{comment.user.name}}
              @if (comment.user.country?.name) {
                <span>({{comment.user.country.name}})</span>
              }
              @if (comment.user.user_title) {
                <div class="feed-item-header-title comment-header-title">
                  {{comment.user.user_title | strLimit:50}}
                </div>
              }
              <span class="time-stamp">{{comment.published_at | relativeDate}}</span>
            </div>
          </a>
          <div class="feed-content">
            <article [innerHTML]="comment.content_built"></article>
            <a (click)="openCommentEditor({parent_id:comment.id, content: '@' + comment.user.slug + ' '})" class="clickable" [attr.data-slide-up-trigger]="slideUpId"><i class="icon icon-reply"></i>Reply</a>
            <div class="func-btns">
              <ut-community-feed-item-flag [item]="comment"></ut-community-feed-item-flag>
              <ut-community-feed-item-like-count [likeable]="comment"></ut-community-feed-item-like-count>
              <ut-community-feed-item-like-btn [likeable]="comment"></ut-community-feed-item-like-btn>
            </div>
          </div>
        </div>
      </div>
    }
    <!-- CommentItems -->

    <!-- Footer -->
    @if (comments.length && (comments.length < commentable.comments.count)) {
      <div class="section-single-comment-short-footer">
        <a class="" [uiSref]="'singlestatus'" [uiParams]="{statusId: commentable.id}">View All Comments</a>
      </div>
    }
    <!-- Footer -->

  </div>

  <!-- Write a comment Form -->
  <section [ngClass]="commentable.type" class="slide-up slide-up-move comment-form" [attr.id]="slideUpId" [utSlideUp]="slideUpId">
    <button class="slide-up-close" (click)="closeCommentForm()" aria-label="Close">
      <i class="material-icons" aria-hidden="true">close</i>
    </button>
    <div class="slide-up-content">
      <form (ngSubmit)="submitComment()">
        <div class="comment-form-rating">
          <h4>Your Rating:</h4>
          <div class="rating clickable">
            <ut-star-rating [(rating)]="newComment.rating" [max]="5" [readonly]="false"></ut-star-rating>
          </div>
        </div>
        <div class="comment-form-reply">
          <label for="slideUpTextArea">{{ newComment.id ? 'Edit' : 'Write' }} your Reply:</label>
          <ut-editor [(value)]="newComment.content" text-area-label="Write your reply here"></ut-editor>
        </div>
        <div class="comment-form-btn">
          <button type="submit" class="btn slide-up-submit">Submit</button>
        </div>
      </form>
    </div>
  </section>
  <!-- /Write a comment Form -->

</div>
